import './App.css';

function App() {
  return (
    <div className="App">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-badge">🚀 Now serving 10,000+ startups worldwide</div>
          <h1 className="hero-title">Turn Your Vision Into Reality in Days, Not Months</h1>
          <p className="hero-description">
            The complete platform that empowers entrepreneurs to build, launch, and scale successful startups with confidence. No technical expertise required.
          </p>
          <div className="hero-cta-group">
            <button className="cta-button primary">Start Free Trial</button>
            <button className="cta-button outline">Watch Demo</button>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">10K+</div>
              <div className="stat-label">Active Users</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">99.9%</div>
              <div className="stat-label">Uptime</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support</div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="social-proof">
        <div className="container">
          <p className="social-proof-text">Trusted by innovative startups and forward-thinking entrepreneurs</p>
          <div className="company-logos">
            <div className="logo-item">TechCorp</div>
            <div className="logo-item">InnovateHub</div>
            <div className="logo-item">StartupLab</div>
            <div className="logo-item">VentureWorks</div>
            <div className="logo-item">CloudScale</div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Everything You Need to Succeed</h2>
            <p className="section-subtitle">Powerful features designed to accelerate your startup journey from zero to hero</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon">⚡</div>
              </div>
              <h3 className="feature-title">Lightning Fast Deployment</h3>
              <p className="feature-description">
                Launch your MVP in minutes with our intuitive platform. Skip the complexity and focus on what matters—your product and customers.
              </p>
              <a href="#learn-more" className="feature-link">Learn more →</a>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon">🔒</div>
              </div>
              <h3 className="feature-title">Enterprise-Grade Security</h3>
              <p className="feature-description">
                Bank-level encryption and 99.9% uptime SLA. Your data and your customers' trust are protected with military-grade security protocols.
              </p>
              <a href="#learn-more" className="feature-link">Learn more →</a>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon">📈</div>
              </div>
              <h3 className="feature-title">Infinite Scalability</h3>
              <p className="feature-description">
                From 10 to 10 million users seamlessly. Our auto-scaling infrastructure grows with your success without any manual intervention.
              </p>
              <a href="#learn-more" className="feature-link">Learn more →</a>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon">💡</div>
              </div>
              <h3 className="feature-title">Smart Analytics</h3>
              <p className="feature-description">
                Real-time insights and actionable data to make informed decisions. Track user behavior, conversion rates, and growth metrics effortlessly.
              </p>
              <a href="#learn-more" className="feature-link">Learn more →</a>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon">🎯</div>
              </div>
              <h3 className="feature-title">AI-Powered Optimization</h3>
              <p className="feature-description">
                Leverage machine learning to optimize your product experience. Our AI suggests improvements based on user patterns and industry benchmarks.
              </p>
              <a href="#learn-more" className="feature-link">Learn more →</a>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon">🌐</div>
              </div>
              <h3 className="feature-title">Global Infrastructure</h3>
              <p className="feature-description">
                Deploy across 50+ regions worldwide. Deliver lightning-fast experiences to your users no matter where they are on the planet.
              </p>
              <a href="#learn-more" className="feature-link">Learn more →</a>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Loved by Founders Worldwide</h2>
            <p className="section-subtitle">See what successful entrepreneurs are saying about Launchify</p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "Launchify reduced our time to market from 6 months to 3 weeks. The platform is incredibly intuitive and powerful."
              </p>
              <div className="testimonial-author">
                <div className="author-info">
                  <div className="author-name">Sarah Chen</div>
                  <div className="author-title">CEO, TechFlow</div>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "The best investment we made for our startup. The ROI was visible within the first month of using Launchify."
              </p>
              <div className="testimonial-author">
                <div className="author-info">
                  <div className="author-name">Michael Rodriguez</div>
                  <div className="author-title">Founder, InnovateLabs</div>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "Outstanding support team and rock-solid infrastructure. We scaled from 100 to 50K users without a single hiccup."
              </p>
              <div className="testimonial-author">
                <div className="author-info">
                  <div className="author-name">Emma Thompson</div>
                  <div className="author-title">CTO, GrowthStack</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call To Action Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Build Your Dream Startup?</h2>
            <p className="cta-description">
              Join 10,000+ successful founders who transformed their ideas into thriving businesses. Start your free 14-day trial today—no credit card required.
            </p>
            <div className="cta-buttons">
              <button className="cta-button primary-white">Start Free Trial</button>
              <button className="cta-button secondary-outline">Schedule a Demo</button>
            </div>
            <div className="cta-features">
              <div className="cta-feature">✓ Free 14-day trial</div>
              <div className="cta-feature">✓ No credit card needed</div>
              <div className="cta-feature">✓ Cancel anytime</div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3 className="footer-logo">Launchify</h3>
              <p className="footer-tagline">Empowering the next generation of innovators and entrepreneurs worldwide.</p>
              <div className="footer-social">
                <a href="#twitter" className="social-link" aria-label="Twitter">𝕏</a>
                <a href="#linkedin" className="social-link" aria-label="LinkedIn">in</a>
                <a href="#github" className="social-link" aria-label="GitHub">GH</a>
                <a href="#youtube" className="social-link" aria-label="YouTube">YT</a>
              </div>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4 className="footer-heading">Product</h4>
                <a href="#features" className="footer-link">Features</a>
                <a href="#pricing" className="footer-link">Pricing</a>
                <a href="#integrations" className="footer-link">Integrations</a>
                <a href="#changelog" className="footer-link">Changelog</a>
                <a href="#docs" className="footer-link">Documentation</a>
              </div>
              <div className="footer-column">
                <h4 className="footer-heading">Company</h4>
                <a href="#about" className="footer-link">About Us</a>
                <a href="#blog" className="footer-link">Blog</a>
                <a href="#careers" className="footer-link">Careers</a>
                <a href="#press" className="footer-link">Press Kit</a>
                <a href="#partners" className="footer-link">Partners</a>
              </div>
              <div className="footer-column">
                <h4 className="footer-heading">Resources</h4>
                <a href="#community" className="footer-link">Community</a>
                <a href="#support" className="footer-link">Support Center</a>
                <a href="#contact" className="footer-link">Contact Us</a>
                <a href="#status" className="footer-link">System Status</a>
                <a href="#api" className="footer-link">API Reference</a>
              </div>
              <div className="footer-column">
                <h4 className="footer-heading">Legal</h4>
                <a href="#privacy" className="footer-link">Privacy Policy</a>
                <a href="#terms" className="footer-link">Terms of Service</a>
                <a href="#security" className="footer-link">Security</a>
                <a href="#gdpr" className="footer-link">GDPR</a>
                <a href="#cookies" className="footer-link">Cookie Policy</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="footer-copyright">&copy; 2024 Launchify, Inc. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="#privacy" className="footer-bottom-link">Privacy</a>
              <a href="#terms" className="footer-bottom-link">Terms</a>
              <a href="#sitemap" className="footer-bottom-link">Sitemap</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;